

export function findEncargoByUUID({ encargos, uuid }) {
  return encargos.find(({ uuid: encargoUUID }) => encargoUUID == uuid);
}

export function findLineaFromEncargo({ encargos, uuid, linea }) {
  const encargoAfectado = findEncargoByUUID({ encargos, uuid });
  if (encargoAfectado !== undefined) {
    const { detalles } = encargoAfectado;
    const lineaAfectada = detalles.find(detalle => detalle.linea == linea);
    if (lineaAfectada) {
      return lineaAfectada;
    }
  }
  return undefined;
}
export function obtenerDetallesSeparados(detalles) {
  const detallesSinConjunto = [];
  const detallesGafasGraduadas = [];
  let indice = 0;
  while (indice < detalles.length) {
    if (detalles[indice].cdgtipo == 3 && detalles[indice + 1] && detalles[indice + 1].cdgtipo == 1 && detalles[indice + 1].articulo.infoLente && detalles[indice + 1].articulo.infoLente.ojo) {
      if (detalles[indice + 2] && detalles[indice + 2].cdgtipo == 1 && detalles[indice + 2].articulo.infoLente && detalles[indice + 2].articulo.infoLente.ojo) {
        detallesGafasGraduadas.push(detalles[indice]);
        detallesGafasGraduadas.push(detalles[indice + 1]);
        detallesGafasGraduadas.push(detalles[indice + 2]);
        indice += 3;
      } else {
        detallesGafasGraduadas.push(detalles[indice]);
        detallesGafasGraduadas.push(detalles[indice + 1]);
        indice += 2;
      }
    } else {
      detallesSinConjunto.push(detalles[indice]);
      indice += 1;
    }
  }
  return { detallesGafasGraduadas, detallesSinConjunto };
}
